import React, { useRef, useState } from "react";
import { FaTrash, FaCopy } from "react-icons/fa";
import { IoCloudUploadSharp } from "react-icons/io5";
import { ImageLink } from "../../constants";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";

const MultiImageUploader = ({
  maxImages = 10,
  onChange,
  initialImages = [],
}) => {
  const [images, setImages] = useState(initialImages);
  const fileInputRef = useRef(null);

const handleFiles = async (files) => {
  const fileArray = Array.from(files).slice(0, maxImages - images.length);
  try {
    const formData = new FormData();
    fileArray.forEach((file) => {
      formData.append("images", file);
    });

    const res = await axiosInstance.post(
      "admin/blogs/blogsMultiImage",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    const uploadedImages = res.data.images.map((img) => img.path);
    const updatedImages = [...images, ...uploadedImages];
    setImages(updatedImages);
    onChange && onChange(updatedImages);

  } catch (err) {
    toast.error(err.response?.data?.message || "Upload failed");
  }
};

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

const handleDelete = async (index) => {
  const path = images[index];

  try {
    await axiosInstance.post("admin/blogs/deleteBlogMultiImage", {
      path, 
    });

    const updated = images.filter((_, i) => i !== index);
    setImages(updated);
    onChange && onChange(updated);

    toast.success("Image deleted successfully");
  } catch (err) {
    toast.error(err.response?.data?.message || "Delete failed");
  }
};

  const handleCopy = (img) => {
    const path = img.preview || img;
    navigator.clipboard.writeText(path);
  };

  return (
    <div>
      <div
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        style={{
          border: "2px dashed #d044ed",
          padding: "20px",
          borderRadius: "10px",
          minHeight: "150px",
          cursor: "pointer",
        }}
        onClick={() => fileInputRef.current.click()}
      >
        {images.length === 0 && (
          <div style={{ textAlign: "center" ,marginTop:"10px"}}>
            <IoCloudUploadSharp size={50} style={{ marginBottom: "0px", color: "#d044ed" }} />
            <p style={{ marginTop: "10px" }}>
              Drag & Drop or Click to Upload (Max {maxImages})
            </p>
          </div>
        )}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          {images.map((img, index) => (
            <div
              key={index}
              style={{
                width: "210px",
                height: "210px",
                position: "relative",
                borderRadius: "8px",
                overflow: "hidden",
                border: "1px solid #ddd",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={ImageLink(img.preview || img)}
                alt="preview"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />

                          <div
                style={{
                  position: "absolute",
                  bottom: "0",
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",

                  padding: "5px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                  }}
                >
                  <div
                    style={{
                      background: "rgba(0,0,0,0.7)",
                      borderRadius: "50%",
                      padding: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => handleCopy(img)}
                  >
                    <FaCopy size={14} color="#fff" />
                  </div>

                  <div
                    style={{
                      background: "rgba(0,0,0,0.7)",
                      borderRadius: "50%",
                      padding: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDelete(index)}
                  >
                    <FaTrash size={14} color="#ff4d4f" />
                  </div>
                </div>
              </div>
            
            </div>
          ))}
        </div>

        <input
          type="file"
          multiple
          hidden
          ref={fileInputRef}
          onChange={(e) => handleFiles(e.target.files)}
        />
      </div>
    </div>
  );
};

export default MultiImageUploader;
